<template>
    <div class="notice">
        <i v-if="showIcon" :class="icon"></i>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Notice',
    props: {
        showIcon: Boolean,
        icon: {
            type: String,
            default: 'iconfont-npm icon-npm-a-lujing244',
        },
    },
};
</script>

<style lang="scss" scoped>
.notice {
    // border: 1px solid #f4e7c0;
    background: #ffffe8;
    padding: 11px 20px;
    margin-bottom: 10px;
    color: #222;

    .iconfont-npm.icon-npm-a-lujing244 {
        color: #ff7300;
        margin-right: 5px;
        font-size: 12px !important;
    }

    a {
        color: #389eff;
    }
}
</style>
